import { App } from "@capacitor/app"
import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { closeMiniApp } from "@/shared/lib/telegram"
import { usePlatform } from "./context"

/**
 * Возвращает функцию выхода из приложения,
 * адаптированную под текущую платформу.
 *
 * - telegram → закрывает Mini App
 * - android → завершает процесс приложения
 * - ios / browser → навигация на главную
 */
export function useExitApp() {
	const platform = usePlatform()
	const navigate = useNavigate()

	return useCallback(() => {
		if (platform === "telegram") {
			closeMiniApp()
		} else if (platform === "android") {
			App.exitApp()
		} else {
			navigate({ to: "/" })
		}
	}, [platform, navigate])
}
